/* eslint-disable camelcase */

import * as t from 'io-ts';

import {makeApiType, RLazyTeammateIdRef} from './apiTypes';
import {MessageTypesEnum, parseMessageType, RMessageType} from './messageModel';

/*
 * Runtime type.
 */

const RSearchSuggestionMatchDirty = t.readonly(
  t.type({
    id: t.number,
    subject: t.string,
    date: t.number,
    recipient: t.union([t.string, t.undefined]),
    teammates: t.union([t.readonlyArray(RLazyTeammateIdRef), t.undefined]),
    messageType: RMessageType,
  }),
);

export const RSearchSuggestionMatches = t.readonlyArray(RSearchSuggestionMatchDirty);

export const RSearchsuggestionsResult = t.readonly(
  t.type({
    results: RSearchSuggestionMatches,
  }),
);

/*
 * Type.
 */

export interface SearchSuggestionMatchModel extends t.TypeOf<typeof RSearchSuggestionMatchDirty> {}

export interface SearchSuggestionsResultModel extends t.TypeOf<typeof RSearchsuggestionsResult> {}

/*
 * IO methods.
 */

export function parseSearchSuggestionMatch(src: any): SearchSuggestionMatchModel {
  return {
    id: src.id,
    subject: src.subject,
    date: src.date,
    recipient: src.contact?.display_name,
    teammates: src.teammates,
    messageType: parseMessageType(src.message_type),
  };
}

export function parseSearchSuggestionMatches(src: any): SearchSuggestionsResultModel {
  const {suggestions} = src;
  return {
    results: suggestions.map(parseSearchSuggestionMatch),
  };
}

/*
 * API type.
 */

export const ApiSearchSuggestionsMatches = makeApiType(
  'searchSuggestionMatches',
  RSearchsuggestionsResult,
  parseSearchSuggestionMatches,
);

/*
 * Type guards.
 */

export function isSuggestionMatchEmail(
  suggestionMatch: SearchSuggestionMatchModel,
): suggestionMatch is SearchSuggestionMatchModel & {messageType: MessageTypesEnum.EMAIL} {
  return suggestionMatch.messageType === MessageTypesEnum.EMAIL;
}

export function isSuggestionMatchInternal(
  suggestionMatch: SearchSuggestionMatchModel,
): suggestionMatch is SearchSuggestionMatchModel & {messageType: MessageTypesEnum.INTERNAL} {
  return suggestionMatch.messageType === MessageTypesEnum.INTERNAL;
}
